import React, { useEffect, useState, useRef } from "react";
import { Toggle } from "rsuite";
import "./opportunity.scss";
import { connect, useDispatch, useSelector } from "react-redux";
import {
	getNIAValueTrackerData,
	getNIAValueTrackerGraphData,
	getNIANegotiationsData,
	getNIANegotiationsGraphData,
} from "../../queries/apiQueries";
import { appInsights } from "../router";
import ValueTracker from "./valueTracker";
import { APPROACH } from "../../utils";
import { CSVLink } from "react-csv";
import MainHeader from "../../components/Layouts/MainHeader";
import { Loader } from "../../components/common/Loader";
import { Segmented } from "antd";
import MainContent from "../../components/Layouts/MainContent";

const NiaNegotiations = (props: any) => {
	const dispatch = useDispatch<any>();
	const approachSelected = useSelector(
		(state: any) => state.CommonReducer.approach
	);

	const [isLoading, setIsLoading] = useState(true);
	const [isGraphLoading, setIsGraphLoading] = useState(true);
	const [approach, setApproach] = useState(
		approachSelected ? approachSelected : "approach1"
	);
	const [selectedSupplier, setSelectedSupplier] = useState<any>(null);
	const [trackerGraphData, setTrackerGraphData] = useState([]);
	const [keyMetricsData, setKeyMetricsData] = useState([]);
	const [trackerData, setTrackerData] = useState([]);
	const [export1Data, setExport1Data] = useState<any>([]);
	const [export2Data, setExport2Data] = useState([]);
	const [page, setPage] = useState("valueTracker");
	const [subsStaus, setSubsStaus] = useState(false);
	const [isVisible, setIsVisible] = useState(false);
	const [isRightVisible, setIsRightVisible] = useState(false);

	useEffect(() => {
		props.onApproachChange(approach);
		appInsights.trackPageView({
			name: `Calling graph data based on the selection of approach, tab, or toggle and initial load of the page`,
		});
		getTrackerGraphData(selectedSupplier);
		getTrackerData();
	}, [approach, page, subsStaus]);

	const getTrackerData = async () => {
		let payload: any = {
			approach: approach,
		};
		if (page == "rebateEstimate" && subsStaus) {
			payload.toggle = 1;
		}
		let res = await dispatch(
			page == "valueTracker"
				? getNIAValueTrackerData(payload)
				: getNIANegotiationsData(payload)
		);
		setTrackerData(res.data);
		let exportData: any = [];
		res.data.map((item: any) => {
			exportData.push({
				Master_Vendor_Name: item.Master_Vendor_Name,
				lastYearCost: `$${item.lastYearCost?.toFixed(2)}`,
				last_rebate: `$${item.last_rebate?.toFixed(2)}`,
				currFSpend: `$${(
					item.currentCost + item.consolidatedcost_Approach
				)?.toFixed(2)}`,
				cur_rebate: `$${item.cur_rebate?.toFixed(2)}`,
				Current_Year_YTD_Rebate: `$${item.Current_Year_YTD_Rebate?.toFixed(
					2
				)}`,
				incrementalRebate: `$${(
					item.cur_rebate - item.last_rebate
				)?.toFixed(2)}`,
			});
		});
		setExport1Data(exportData);
		setIsLoading(false);
	};

	const getTrackerGraphData = async (supplier: any = null) => {
		let payloadObject: any = {
			approach: approach,
		};
		if (supplier) {
			payloadObject.master_vendor_name = supplier;
		}

		if (page == "rebateEstimate" && subsStaus) {
			payloadObject.toggle = 1;
		}
		let res = await dispatch(
			page == "valueTracker"
				? getNIAValueTrackerGraphData(payloadObject)
				: getNIANegotiationsGraphData(payloadObject)
		);
		let cumulativeRebateDiff = 0;
		res.data?.map((item: any) => {
			cumulativeRebateDiff = cumulativeRebateDiff + item.rebateDiff;
			item.cumulativeRebateDifference = cumulativeRebateDiff;
		});
		setTrackerGraphData(res.data);

		let exportData: any = [];
		res.data.map((item: any) => {
			let monthName = null;
			if (item.Month == 1) {
				monthName = "Jan";
			} else if (item.Month == 2) {
				monthName = "Feb";
			} else if (item.Month == 3) {
				monthName = "Mar";
			} else if (item.Month == 4) {
				monthName = "Apr";
			} else if (item.Month == 5) {
				monthName = "May";
			} else if (item.Month == 6) {
				monthName = "Jun";
			} else if (item.Month == 7) {
				monthName = "Jul";
			} else if (item.Month == 8) {
				monthName = "Aug";
			} else if (item.Month == 9) {
				monthName = "Sep";
			} else if (item.Month == 10) {
				monthName = "Oct";
			} else if (item.Month == 11) {
				monthName = "Nov";
			} else if (item.Month == 12) {
				monthName = "Dec";
			}
			exportData.push({
				Month: monthName,
				lastYearSpend: `$${item.lastyear?.toFixed(2)}`,
				currSpend: `$${item.YTD?.toFixed(2)}`,
				incrementalRebate: `$${item.cumulativeRebateDifference?.toFixed(
					2
				)}`,
			});
		});
		setExport2Data(exportData);

		setKeyMetricsData(res.keyMetrics);
		setIsGraphLoading(false);
	};

	return isLoading || isGraphLoading ? (
		<Loader />
	) : (
		<div className="opportunities-dashboard-container w-full">
			<MainHeader
				onVisibilityChange={setIsVisible}
				isRightVisible={isRightVisible}
				setIsRightVisible={setIsRightVisible}
				topContent={
					<>
						<div className="flex justify-between items-center w-full">
							<div className="text-left pageline">
								<span className="pagelinestart">Tracking</span>{" "}
								<span className="pagelineslash">/</span>{" "}
								<span className="pagelinesub">
									NIA Negotiations
								</span>
							</div>
						</div>
						<div className="execution-level-wrapper">
							<div className="execution-level-title">View By</div>
							<Segmented
								options={[
									{
										label: "Value Tracker",
										value: "valueTracker",
									},
									{
										label: "Overall Rebate Estimates",
										value: "rebateEstimate",
									},
								]}
								value={page}
								onChange={setPage}
							/>
						</div>
						{page === "rebateEstimate" && (
							<Segmented
								options={[
									{ label: "Subs Include", value: true },
									{ label: "Subs Exclude", value: false },
								]}
								value={subsStaus}
								onChange={setSubsStaus}
							/>
						)}
					</>
				}
			></MainHeader>
			<MainContent isVisible={isVisible} fullHeight={true}>
				<div className="chart-flexs h-[100%]">
					{
						<ValueTracker
							data={trackerData}
							export1Data={export1Data}
							export2Data={export2Data}
							approach={approach}
							updateApproach={(data: any) => {
								setApproach(data);
							}}
							selectedSupplier={selectedSupplier}
							updateSelectedSupplier={(data: any) => {
								setSelectedSupplier(data);
								getTrackerGraphData(data);
							}}
							trackerGraphData={trackerGraphData}
							keyMetricsData={keyMetricsData}
						/>
					}
				</div>
			</MainContent>
		</div>
	);
};

const mapDispatchToProps = (dispatch: any) => ({
	onApproachChange: (data: any) => dispatch({ type: APPROACH, data: data }),
});

export default connect(null, mapDispatchToProps)(NiaNegotiations);
